import Header from "../../components/shared/Header";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Hero from "./Hero";
import OurProducts from "./OurProducts";
import Roadmap from "./Roadmap";
import Tokenomics from "./Tokenomics";
import Footer from "../../components/shared/Footer";
import Loader from "../../components/shared/Loader";
import { useEffect, useState } from "react";

export default function Home() {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		document.body.style.overflowY = "hidden"; // Prevent scrolling

		const images = document.querySelectorAll("img");
		let loadedCount = 0;

		images.forEach((img) => {
			if (img.complete) {
				loadedCount++;
			} else {
				img.onload = () => {
					loadedCount++;
					if (loadedCount === images.length) {
						setLoading(false);
						document.body.style.overflowY = "auto"; // Enable scrolling
					}
				};
			}
		});

		// If all images are already loaded
		if (loadedCount === images.length) {
			setLoading(false);
			document.body.style.overflowY = "auto";
		}

		return () => {
			document.body.style.overflowY = "auto"; // Cleanup
		};
	}, []);

	return (
		<>
			{process.env.NODE_ENV === "development" && (
				<div className="fps-stats">
					{(() => {
						const FPSStats = require("react-fps-stats").default;
						//return <FPSStats />;
					})()}
				</div>
			)}

			<Loader loading={loading} />

			<Header />

			<Hero />

			<AboutUs />

			<OurProducts />

			<Roadmap />

			<Tokenomics />

			<ContactUs />

			<Footer />
		</>
	);
}
